import React from 'react';
import './style.scss';
import SVGFightWin from '../../../../../../assets/images/roundResults/win';
import SVGFightDraw from '../../../../../../assets/images/roundResults/draw';
import SVGFightLose from '../../../../../../assets/images/roundResults/lose';

export type RoundResults = 'win' | 'lose' | 'draw';

interface Props {
  time: number;
  results?: RoundResults;
}

const BattleActionInfo = ({ time, results }: Props) => (
  <div className='fight-action-info'>
    {results ? (
      <div className='fight-action-info-results'>
        <Results results={results} />
      </div>
    ) : time >= 0 ? (
      <Timer time={time} />
    ) : null}
  </div>
);

interface TimerProps {
  time: number;
}

const Timer = ({ time }: TimerProps) => {
  const minutes = Math.trunc(time / 60);
  const seconds = time % 60;
  return (
    <span>
      {minutes}:{seconds}
    </span>
  );
};

interface ResultsProps {
  results: RoundResults;
}

const Results = ({ results }: ResultsProps) => {
  switch (results) {
    case 'win':
      return <SVGFightWin />;
    case 'lose':
      return <SVGFightLose />;
    default:
      return <SVGFightDraw />;
  }
};

export default BattleActionInfo;
